/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DocumentoPublicoResponse,
  ErroResponse,
  VerificacaoDeReceitaResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getDocumentosPublicoControllerObterUrl = (token: string,) => {




  return `/v1/documentos/${token}`
}

/**
 * @summary Cabeçalho do documento compartilhado (link público).
 */
export const documentosPublicoControllerObter = async (token: string, options?: Parameters<typeof httpClient>[1]): Promise<DocumentoPublicoResponse> => {

  return httpClient<DocumentoPublicoResponse>(getDocumentosPublicoControllerObterUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDocumentosPublicoControllerObterQueryKey = (token: string,) => {
    return [
    `/v1/documentos/${token}`
    ] as const;
    }


export const getDocumentosPublicoControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof documentosPublicoControllerObter>>, TError = ErroResponse>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentosPublicoControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentosPublicoControllerObterQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentosPublicoControllerObter>>> = ({ signal }) => documentosPublicoControllerObter(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentosPublicoControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DocumentosPublicoControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof documentosPublicoControllerObter>>>
export type DocumentosPublicoControllerObterQueryError = ErroResponse


export function useDocumentosPublicoControllerObter<TData = Awaited<ReturnType<typeof documentosPublicoControllerObter>>, TError = ErroResponse>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentosPublicoControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentosPublicoControllerObter>>,
          TError,
          Awaited<ReturnType<typeof documentosPublicoControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentosPublicoControllerObter<TData = Awaited<ReturnType<typeof documentosPublicoControllerObter>>, TError = ErroResponse>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentosPublicoControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentosPublicoControllerObter>>,
          TError,
          Awaited<ReturnType<typeof documentosPublicoControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentosPublicoControllerObter<TData = Awaited<ReturnType<typeof documentosPublicoControllerObter>>, TError = ErroResponse>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentosPublicoControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Cabeçalho do documento compartilhado (link público).
 */

export function useDocumentosPublicoControllerObter<TData = Awaited<ReturnType<typeof documentosPublicoControllerObter>>, TError = ErroResponse>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentosPublicoControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentosPublicoControllerObterQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDocumentosPublicoControllerPdfUrl = (token: string,) => {




  return `/v1/documentos/${token}/pdf`
}

/**
 * @summary PDF do documento compartilhado (link público).
 */
export const documentosPublicoControllerPdf = async (token: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getDocumentosPublicoControllerPdfUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDocumentosPublicoControllerPdfQueryKey = (token: string,) => {
    return [
    `/v1/documentos/${token}/pdf`
    ] as const;
    }


export const getDocumentosPublicoControllerPdfQueryOptions = <TData = Awaited<ReturnType<typeof documentosPublicoControllerPdf>>, TError = Blob>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentosPublicoControllerPdf>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentosPublicoControllerPdfQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentosPublicoControllerPdf>>> = ({ signal }) => documentosPublicoControllerPdf(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentosPublicoControllerPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DocumentosPublicoControllerPdfQueryResult = NonNullable<Awaited<ReturnType<typeof documentosPublicoControllerPdf>>>
export type DocumentosPublicoControllerPdfQueryError = Blob


export function useDocumentosPublicoControllerPdf<TData = Awaited<ReturnType<typeof documentosPublicoControllerPdf>>, TError = Blob>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentosPublicoControllerPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentosPublicoControllerPdf>>,
          TError,
          Awaited<ReturnType<typeof documentosPublicoControllerPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentosPublicoControllerPdf<TData = Awaited<ReturnType<typeof documentosPublicoControllerPdf>>, TError = Blob>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentosPublicoControllerPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentosPublicoControllerPdf>>,
          TError,
          Awaited<ReturnType<typeof documentosPublicoControllerPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentosPublicoControllerPdf<TData = Awaited<ReturnType<typeof documentosPublicoControllerPdf>>, TError = Blob>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentosPublicoControllerPdf>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary PDF do documento compartilhado (link público).
 */

export function useDocumentosPublicoControllerPdf<TData = Awaited<ReturnType<typeof documentosPublicoControllerPdf>>, TError = Blob>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentosPublicoControllerPdf>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentosPublicoControllerPdfQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getVerificacaoPublicaControllerVerificarUrl = (codigo: string,) => {




  return `/v1/verificacao/receituarios/${codigo}`
}

/**
 * @summary Verificação pública da receita de controle especial (QR do PDF).
 */
export const verificacaoPublicaControllerVerificar = async (codigo: string, options?: Parameters<typeof httpClient>[1]): Promise<VerificacaoDeReceitaResponse> => {

  return httpClient<VerificacaoDeReceitaResponse>(getVerificacaoPublicaControllerVerificarUrl(codigo),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVerificacaoPublicaControllerVerificarQueryKey = (codigo: string,) => {
    return [
    `/v1/verificacao/receituarios/${codigo}`
    ] as const;
    }


export const getVerificacaoPublicaControllerVerificarQueryOptions = <TData = Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>, TError = ErroResponse>(codigo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerificacaoPublicaControllerVerificarQueryKey(codigo);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>> = ({ signal }) => verificacaoPublicaControllerVerificar(codigo, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: codigo !== null && codigo !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VerificacaoPublicaControllerVerificarQueryResult = NonNullable<Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>>
export type VerificacaoPublicaControllerVerificarQueryError = ErroResponse


export function useVerificacaoPublicaControllerVerificar<TData = Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>, TError = ErroResponse>(
 codigo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>,
          TError,
          Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerificacaoPublicaControllerVerificar<TData = Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>, TError = ErroResponse>(
 codigo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>,
          TError,
          Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerificacaoPublicaControllerVerificar<TData = Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>, TError = ErroResponse>(
 codigo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Verificação pública da receita de controle especial (QR do PDF).
 */

export function useVerificacaoPublicaControllerVerificar<TData = Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>, TError = ErroResponse>(
 codigo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificacaoPublicaControllerVerificar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVerificacaoPublicaControllerVerificarQueryOptions(codigo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






